import React, { useEffect, useState } from 'react';
import '../../Calendar.css';
import '@progress/kendo-theme-default/dist/all.css';
import { SchedulerViewItem } from "@progress/kendo-react-scheduler";
import {
    load,
    loadMessages,
} from "@progress/kendo-react-intl";
import frCaGregorian from 'cldr-data/main/fr/ca-gregorian.json';
import frNumbers from 'cldr-data/main/fr/numbers.json';
import frCurrencies from 'cldr-data/main/fr/currencies.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import '../../css/CalendarCustom.css'; // Importez le fichier CSS personnalisé
import frMessages from "../../Mock/formatDate.json";
import { useLocation } from "react-router-dom";
import { useConf } from '../../context/account/paramsAccount';
import { getFirstDayOfMonth, getLastDayOfMonth } from '../../functions/date/getFirstLastDay';
import { useError } from '../../context/erreur/erreurContext';
import { hookApi } from '../../hook/presta/affichePrestaHook';
import MonthAgenda from './monthCalendrier';
loadMessages(frMessages, "fr");

// Chargez les fichiers de localisation pour le français
load(frCaGregorian, frNumbers, frCurrencies, weekData);


// const CustomItem = (props: any) => {
//     const { pastilleColor, backgroundTacheColor } = CustomColorItem(props);
//     const dateString = props.start;
//     const date = new Date(dateString);
//     const timeString = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

//     return (
//         <SchedulerItem  {...props} style={{ ...props.style, backgroundColor: backgroundTacheColor }} >
//             <div key={props.dataItem.id} style={{ display: 'flex', alignItems: 'center', fontSize: ' clamp(0.625rem, 0.408rem + 0.5208vw, 1.25rem);', padding: '5px' }}>
//                 <div>
//                     <p style={{ paddingLeft: '0.5rem' }}>{timeString}</p>
//                     <span>{props.children}</span>
//                     <span style={{ paddingLeft: '0.5rem' }}>{props.dataItem.v_type_presta}</span>
//                 </div>
//                 <span className="pastille" style={{ backgroundColor: pastilleColor }}></span>
//             </div>
//         </SchedulerItem>
//     );
// }


export function Calendar() {
    const { conf, setConf }: any = useConf()
    const location = useLocation();
    const [currentView, setCurrentView] = useState('month');
    const [currentDate, setCurrentDate] = useState(new Date());
    const { showError } = useError();
    const [changeDate, setChangeDate]: any = useState(null)

    useEffect(() => {
        if (location.pathname.includes('semaine')) {
            setCurrentView('week');
        } else if (location.pathname.includes('jour')) {
            setCurrentView('day');
        } else {
            setCurrentView('month');
        }
    }, [location]);
    const fetchData = () => {
        if (currentView === 'month') {
            const dateData = { e_date_deb: getFirstDayOfMonth(currentDate), e_date_fin: getLastDayOfMonth(currentDate), e_soc_id: conf?.user?.site?.soc_id, url: conf?.user?.url };
            hookApi('/posts/planning', dateData, conf, setConf, setChangeDate, showError)
        } else {
            const dateData = { e_date_deb: new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)), e_date_fin: new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0)), e_soc_id: conf?.user?.site?.soc_id, url: conf.user.url, token: conf.token };
            hookApi('/posts/planning', dateData, conf, setConf, setChangeDate, showError)
        }
    };

    useEffect(() => {
        if (conf.token) {
            fetchData();
            const interval = setInterval(fetchData, 3600000);
            return () => clearInterval(interval);
        }

    }, [currentView, currentDate, conf.token]);
    return (
        <div className='containerAll'>
            <MonthAgenda></MonthAgenda>
        </div>

    );
}

export const CustomViewItem = (props: any) => {
    return (
        <SchedulerViewItem
            {...props}
            key={props.id}
            style={{
                ...props.style,
                height: "auto",
            }}
        />
    );
};
